// Helper to generate days for a given month and year
export const generateDaysInMonth = (year, month) => {
  const firstDayOfMonth = new Date(year, month, 1).getDay(); // Get the day of the week (0=Sunday, 1=Monday, etc.)
  const totalDays = new Date(year, month + 1, 0).getDate(); // Get the number of days in the month

  const days = [];

  // Add empty days until the first day of the month (for correct alignment)
  for (let i = 0; i < firstDayOfMonth; i++) {
    days.push("");
  }

  // Fill in the actual days of the month
  for (let i = 1; i <= totalDays; i++) {
    days.push(i);
  }

  return days;
};

export const FY_MONTH = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

export const WEEK_DAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

export const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const trainingDetails = [
  {
    year: 2024,
    month: "April",
    day: 3,
    location: "Chennai",
    startTime: "12pm",
    endTime: "2pm",
    title: "CR Training",
  },
  {
    year: 2024,
    month: "April",
    day: 4,
    location: "Chennai",
    startTime: "12pm",
    endTime: "2pm",
    title: "CR Training",
  },
  {
    year: 2024,
    month: "August",
    day: 10,
    location: "Chennai",
    startTime: "12pm",
    endTime: "2pm",
  },
  {
    year: 2024,
    month: "August",
    day: 19,
    location: "Chennai",
    startTime: "12pm",
    endTime: "2pm",
  },
  {
    year: 2024,
    month: "September",
    day: 3,
    location: "Chennai",
    startTime: "12pm",
    endTime: "2pm",
  },
  {
    year: 2024,
    month: "October",
    day: 15,
    location: "Chennai",
    startTime: "12pm",
    endTime: "2pm",
    title: "CR Training",
  },
  {
    year: 2024,
    month: "October",
    day: 16,
    location: "Chennai",
    startTime: "12pm",
    endTime: "2pm",
    title: "Simpson Training",
  },
  {
    year: 2024,
    month: "November",
    day: 18,
    location: "Chennai",
    startTime: "12pm",
    endTime: "2pm",
    title: "CR Training",
  },
];

export const getCourseDesiredForm = () => [
  /*  {
    name: "courseDesired",
    type: "text",
    label: "Course Desired",
    placeholder: "SJV232598",
    required: true,
  },
  */ {
    label: "Course Start Date",
    name: "courseStartDate",
    type: "dateTimePicker",
    required: true,
  },
  {
    label: "Course End Date",
    name: "courseEndDate",
    type: "dateTimePicker",
    required: true,
  },
];

const getFinancialYears = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  const financialYearStart = currentMonth >= 3 ? currentYear : currentYear - 1;
  const financialYearEnd = financialYearStart + 1;

  return [
    {
      label: `${financialYearStart}-${financialYearEnd}`,
      value: financialYearStart,
    },
    {
      label: `${financialYearEnd}-${financialYearEnd + 1}`,
      value: financialYearEnd,
    },
  ];
};

// Define the financial year options
export const financialYears = getFinancialYears();

export const selectYearForm = [
  {
    label: "Select a year",
    name: "currentYear",
    type: "autocomplete",
    options: financialYears,
  },
];

export const statusTypes = [
  "CREATED",
  "PENDING",
  "BOOKED",
  "COMPLETED",
  "REJECTED",
];
